import { Tag } from "antd";
import type { ReactNode } from "react";

/** Semantic tone → AntD Tag color. Centralizes status colors used across modules. */
export type StatusTone = "default" | "success" | "processing" | "warning" | "error";

const TONE_COLOR: Record<StatusTone, string> = {
	default: "default",
	success: "success",
	processing: "processing",
	warning: "warning",
	error: "error",
};

interface StatusTagProps {
	tone: StatusTone;
	children: ReactNode;
}

/**
 * Status tag with a single source of truth for tone→color mapping.
 * Use instead of hardcoding `<Tag color="green">` etc. per module.
 */
export function StatusTag({ tone, children }: StatusTagProps) {
	return <Tag color={TONE_COLOR[tone]}>{children}</Tag>;
}
